import React, { Fragment } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Card, Form, Table } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import PaginationComp from "../../../components/Pagination";
import { fetchWrapper } from "../../../_helpers/fetchWrapper";
import { StyledTable } from "../../../components/Reusables";
import moment from "moment";

const DailySymptoms = () => {
  const { id, pageNum, trimester } = useParams();
  const [trimesterState, setTrimesterState] = useState(
    trimester === "first"
      ? "FirstTrimester"
      : trimester === "second"
      ? "SecondTrimester"
      : "ThirdTrimester"
  );
  const history = useHistory();
  const [dailySymptoms, setDailySymptoms] = useState(null);
  const [page, setPage] = useState(pageNum);
  const handleSetPage = (page) => {
    setPage(page);
    history.push(`${page}`);
  };

  useEffect(() => {
    const getDailySymptoms = async () => {
      let response = await fetchWrapper.get(
        `/patient/profile/${id}/dailySymptoms?page=${pageNum}&symptomsType=${trimesterState}`
      );
      setDailySymptoms(response);
    };
    try {
      getDailySymptoms();
    } catch (error) {}
  }, [id, pageNum, trimesterState]);
  //
  return (
    <Fragment>
      <Card>
        <div>
          <div className="d-flex p-3 align-items-center">
            <Form.Label htmlFor="trimester-select" className="mr-3 my-0">
              Trimester
            </Form.Label>
            <Form.Control
              as="select"
              id="trimester-select"
              className="w-25"
              onChange={(e) => setTrimesterState(e.target.value)}
            >
              <option value="" disabled>
                Select Trimester
              </option>
              <option
                value="FirstTrimester"
                {...(trimesterState === "FirstTrimester" && { selected: true })}
              >
                First Trimester {trimester === "first" && "::Active"}
              </option>
              <option
                value="SecondTrimester"
                {...(trimesterState === "SecondTrimester" && {
                  selected: true,
                })}
              >
                Second Trimester {trimester === "second" && "::Active"}
              </option>
              <option
                value="ThirdTrimester"
                {...(trimesterState === "ThirdTrimester" && { selected: true })}
              >
                Third Trimester {trimester === "third" && "::Active"}
              </option>
            </Form.Control>
          </div>
          <StyledTable>
            <Table striped responsive hover>
              {trimesterState === "FirstTrimester" ? (
                <thead>
                  <tr>
                    <th rowSpan={2}>Date/Time</th>
                    <th rowSpan={2}>Symptoms Type</th>
                    <th rowSpan={2}>Symptoms</th>
                    <th colSpan={12} className="text-center">
                      Symptoms
                    </th>
                    <th rowSpan={2}>Sucidal Thoughts</th>
                    <th rowSpan={2}>Depression</th>
                    <th rowSpan={2}>Anxiety</th>
                    <th rowSpan={2}>Happiness</th>
                    <th rowSpan={2}>Dizziness</th>
                    <th rowSpan={2}>Others</th>
                  </tr>
                  <tr>
                    <th>PV Bleeding</th>
                    <th>PV Discharge</th>
                    <th>PV Discharge Foul Smelling</th>
                    <th>PV Show</th>
                    <th>PV Spotting</th>
                    <th>Abdominal Distension</th>
                    <th>Abdominal Pain</th>
                    <th>Decreased Appetite</th>
                    <th>Dizziness</th>
                    <th>Fever</th>
                    <th>Nausea</th>
                    <th>Vomiting</th>
                  </tr>
                </thead>
              ) : (
                <thead>
                  <tr>
                    <th rowSpan={3}>Date/Time</th>
                    <th rowSpan={3}>Symptoms Type</th>
                    <th rowSpan={3} className="text-center">
                      Symptoms
                    </th>
                    <th colSpan={19} className="text-center">
                      Symptoms
                    </th>
                    <th rowSpan={3}>Sucidal Thoughts</th>
                    <th rowSpan={3}>Depression</th>
                    <th rowSpan={3}>Anxiety</th>
                    <th rowSpan={3}>Happiness</th>
                    <th rowSpan={3}>Dizziness</th>
                    <th rowSpan={3}>Others</th>
                  </tr>
                  <tr>
                    <th rowSpan={2} className="text-center">
                      Decreased Fetal Movement
                    </th>
                    <th rowSpan={2} className="text-center">
                      Upper Abdominal Pain
                    </th>
                    <th rowSpan={2} className="text-center">
                      Back Pain
                    </th>
                    <th rowSpan={2} className="text-center">
                      Jaundice
                    </th>
                    <th rowSpan={2} className="text-center">
                      Engorged Breast
                    </th>
                    <th rowSpan={2} className="text-center">
                      Cough
                    </th>
                    <th rowSpan={2} className="text-center">
                      Headache
                    </th>
                    <th rowSpan={2} className="text-center">
                      Blurring Of Vision
                    </th>
                    <th rowSpan={2} className="text-center">
                      Convulsions
                    </th>
                    <th rowSpan={2} className="text-center">
                      Shortness Of Breath
                    </th>
                    <th rowSpan={2} className="text-center">
                      Burning Urination
                    </th>
                    <th rowSpan={2} className="text-center">
                      Diarrhoea
                    </th>
                    <th rowSpan={2} className="text-center">
                      Constipation
                    </th>
                    <th rowSpan={2} className="text-center">
                      Water Break
                    </th>

                    <th className="text-center" colSpan={2}>
                      Lower Abdominal Pain
                    </th>
                    <th className="text-center" colSpan={3}>
                      Swelling
                    </th>
                  </tr>
                  <tr>
                    <th className="text-center">Continuous</th>
                    <th className="text-center">Episodic</th>
                    <th className="text-center">Face</th>
                    <th className="text-center">Feet</th>
                    <th className="text-center">Whole Body</th>
                  </tr>
                </thead>
              )}
              {trimesterState === "FirstTrimester" ? (
                <tbody>
                  {dailySymptoms?.results?.map((symptom) => (
                    <tr key={symptom?._id}>
                      <td>
                        {symptom?.postedAt}{" "}
                        {moment(symptom?.createdAt).format("hh:mm A")}
                      </td>
                      <td>{symptom?.symptomsType}</td>
                      <td>{symptom?.noSymptoms ? "No" : "Yes"}</td>
                      <td>{symptom?.PVBleeding ? "Yes" : "No"}</td>
                      <td>{symptom?.PVDischarge ? "Yes" : "No"}</td>
                      <td>{symptom?.PVDischargeFoulSmelling ? "Yes" : "No"}</td>
                      <td>{symptom?.PVShow ? "Yes" : "No"}</td>
                      <td>{symptom?.PVSpotting ? "Yes" : "No"}</td>
                      <td>{symptom?.abdominalDistension}</td>
                      <td>{symptom?.abdominalPain}</td>
                      <td>{symptom?.decreasedAppetite}</td>
                      <td>{symptom?.dizziness}</td>
                      <td>{symptom?.fever ? "Yes" : "No"}</td>
                      <td>{symptom?.nausea}</td>
                      <td>{symptom?.vomiting}</td>
                      <td>{symptom?.selfHarm}</td>
                      <td>{symptom?.stress}</td>
                      <td>{symptom?.peace}</td>
                      <td>{symptom?.happiness}</td>
                      <td>{symptom?.sadness}</td>
                      <td>{symptom?.other}</td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  {dailySymptoms?.results?.map((symptom) => (
                    <tr key={symptom?._id}>
                      <td>
                        {symptom?.postedAt}{" "}
                        {moment(symptom?.createdAt).format("hh:mm A")}
                      </td>
                      <td>{symptom?.symptomsType}</td>
                      <td>{symptom?.noSymptoms ? "No" : "Yes"}</td>
                      <td className="text-center">
                        <span>
                          {symptom?.decreasedFetalMovement ? "Yes" : "No"}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.upperAbdominalPain === 10
                              ? "emergency-badge"
                              : ""
                          }
                        >
                          {symptom?.upperAbdominalPain}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.backPain === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.backPain}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.jaundice === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.jaundice}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.engorgedBreast === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.engorgedBreast}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={symptom?.cough === 10 && "emergency-badge"}
                        >
                          {symptom?.cough}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.headache === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.headache}
                        </span>
                      </td>
                      <td className="text-center">
                        <span>{symptom?.blurringOfVision ? "Yes" : "No"}</span>
                      </td>
                      <td className="text-center">
                        <span>{symptom?.convulsions ? "Yes" : "No"}</span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.shortnessOfBreath === 10 &&
                            "emergency-badge"
                          }
                        >
                          {symptom?.shortnessOfBreath}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.burningUrination === 10 &&
                            "emergency-badge"
                          }
                        >
                          {symptom?.burningUrination}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.Diarrhea === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.Diarrhea ? "Yes" : "No"}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.constipation === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.constipation}
                        </span>
                      </td>
                      <td className="text-center">
                        <span>{symptom?.waterBreak ? "Yes" : "No"}</span>
                      </td>

                      <td className="text-center">
                        <span
                          className={
                            symptom?.lowerAbdominalPain?.continuous === 10 &&
                            "emergency-badge"
                          }
                        >
                          {symptom?.lowerAbdominalPain?.continuous}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.lowerAbdominalPain?.episodic === 10 &&
                            "emergency-badge"
                          }
                        >
                          {symptom?.lowerAbdominalPain?.episodic}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.swelling?.face === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.swelling?.face}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.swelling?.feet === 10 && "emergency-badge"
                          }
                        >
                          {symptom?.swelling?.feet}
                        </span>
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            symptom?.swelling?.wholeBody === 10 &&
                            "emergency-badge"
                          }
                        >
                          {symptom?.swelling?.wholeBody}
                        </span>
                      </td>
                      <td>{symptom?.selfHarm}</td>
                      <td>{symptom?.stress}</td>
                      <td>{symptom?.peace}</td>
                      <td>{symptom?.happiness}</td>
                      <td>{symptom?.sadness}</td>
                      <td>{symptom?.other}</td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </StyledTable>
        </div>
      </Card>
      <PaginationComp
        page={page}
        total={dailySymptoms?.totalResults}
        setPage={handleSetPage}
      />
    </Fragment>
  );
};

export default DailySymptoms;
